import { Dropdown } from './Dropdown';

import SmoothScroll from 'smooth-scroll';

export class FilterDropdown extends Dropdown {
  /**
   * @desc The node holding all of the items that need filtering.
   *
   * @type {HTML Node}
   */
  filterContent;

  /**
   * @desc The nodes that can be filtered.
   *
   * @type {HTML Nodes}
   */
  filterItems;

  /**
   * @desc Filter item hidden class name.
   *
   * @type {String}
   */
  hiddenClass = 'dashboard__filter-item-hidden';

  /**
   * @desc Filter content animation class name.
   *
   * @type {String}
   */
  animationClass = 'dashboard__filter-content-animation';

  /**
   * @desc The smooth-scroll object.
   *
   * @type {Object}
   */
  smoothScroll;

  /**
   * @desc The smooth-scroll object.
   *
   * @type {Object}
   */
  smoothScrollOptions;

  /**
   * @class
   *
   * @extends {BaseClass}
   *
   * @desc
   *
   * @param {HTMLNode} dropdownEl
   */
  constructor(identifier) {
    super(identifier);
    if (this.targetExists()) {
      this.filterContent = document.querySelector('.dashboard__filter-content');
      console.log(this.filterContent);
      this.filterItems = this.filterContent.querySelectorAll(
        '.dashboard__filter-item'
      );
      this.scrollSetup();
    }
  }

  /**
   * @desc Change the video source
   *
   * @param {HTML Object} dropdownOption
   */
  onChange = (dropdownOption) => {
    const term = dropdownOption.innerText;
    this.filterContent.classList.remove(this.animationClass);
    this.filterItems.forEach((filterItem) => {
      // Hide and unhide filter items
      if (!this.matchTerms(term, filterItem)) {
        filterItem.classList.add(this.hiddenClass);
      } else {
        filterItem.classList.remove(this.hiddenClass);
      }
      // Scroll to content
      this.animateScroll();
    });
    // Animate filtered items into view
    this.filterContent.classList.add(this.animationClass);
  };

  /**
   * @desc Setup the smooth scroll object
   */
  scrollSetup = () => {
    this.smoothScrollOptions = {
      speed: 500,
      offset: this.filterScrollOffset,
    };
    this.smoothScroll = new SmoothScroll();
  };

  /**
   * @desc Controls the offset of the smooth scroll destination
   */
  filterScrollOffset = () => {
    let offset = 15;

    if (!!document.querySelector('#toolbar-administration')) {
      offset += 80;
    }
    return offset;
  };

  /**
   * @desc Animate the smooth scroll object
   */
  animateScroll = () => {
    this.smoothScroll.animateScroll(
      this.filterContent,
      null,
      this.smoothScrollOptions
    );
  };
}
